import { PropsWithChildren } from 'react';
import { Button, MantineProvider } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import styles from './NavbarPage.module.css';
import { mantineDarkTheme } from '../../theme';
import { useAuth } from '../../auth';

export function NavbarPage({ children }: PropsWithChildren<unknown>) {
  const auth = useAuth();
  const { t } = useTranslation();

  return (
    <div className={styles['pageContainer']}>
      <MantineProvider theme={mantineDarkTheme}>
        <div className={styles['navbarContainer']}>
          <img className={styles['logo']} src='/hagerty_logo.svg' alt='Hagerty' />
          <Button
            onClick={auth.logout}
            variant='subtle'
            color='red'
            rightIcon={<IconLogout size={14} />}
          >
            {t('navbar.logout')}
          </Button>
        </div>
      </MantineProvider>
      {children}
    </div>
  );
}
